import michigan from '../assets/michigan_html';
import michigan_sql from "../assets/michigan-sql.png";
import michiganCss from "../assets/michigancss.png";
import michiganJs from "../assets/michiganjs.png";
import intro from '../assets/intro_front_end';
import html_css from '../assets/html_css';
import professional_cert from '../assets/professioanl_cert.png';
import react_basic from '../assets/react_basic';
import advanced_react from "../assets/advanced_react"
import javascript_img from '../assets/javascript_1.png';
import v_control from "../assets/version_controls.png";
import ux_ui from '../assets/ux_ui';
import version_control from '../assets/aws_code_build';
import interview_preparation from "../assets/interview_preparation";
import developer_capstone from "../assets/developer-capstone"
import jira2 from "../assets/jira2.png";
import trello from "../assets/trello.png";
import IBMREACT from "../assets/IBM-REACT-CERTIFICATE_LANDING_PAGE_.png";
import TypeScriptCert from "../assets/TypeScript-cert.jpg";


const data = {
    cardData:[
        {
            id:1,
            img: professional_cert,
            title: "Meta Front-End Developer Professional Certificate",
            link: 'https://coursera.org/share/4fee474aaad0b8dc66e6e8e8ae90bea3',
        },

        {
            id:2,
            img: IBMREACT,
            title: "IBM Developing Front-End Apps with React",
            link: 'https://coursera.org/share/48b46f5817b484392713beb286cac1f5',
        },

        {
            id:3,
            img: michiganJs,
            title: "Interactivity with JavaScript",
            link: 'https://www.coursera.org/account/accomplishments/verify/T9HFGTVDZ292?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=sharing_cta&utm_product=course',
        },
        {
            id:4,
            img: TypeScriptCert,
            title: "Mastering TypeScript - 2025 Edition",
            link: 'https://activedgetechnologies.udemy.com/certificate/UC-82eec151-c848-4cdf-9459-e45a35ede7e2/',
        },
        {
            id:5,
            img: michiganCss,
            title: "Introduction to CSS",
            link: "https://www.coursera.org/account/accomplishments/verify/CJE4LBHUQ4DK?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=sharing_cta&utm_product=course",
        },
        {
            id:6,
            img: html_css,
            title: "HTML and CSS in Depth",
            link: 'https://www.coursera.org/learn/html-and-css-in-depth/home/week/1?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=sharing_cta',
        },
        {
            id:7,
            img: intro,
            title: "Introduction to Front-End Development",
            link: 'https://coursera.org/share/b79ba831134bbef23c36768ca071b9d4',
        },
        {
            id:8,
            img: jira2,
            title: "Jira Project Management System",
            link: "https://www.coursera.org/account/accomplishments/verify/F698AXQMSNQL?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=sharing_cta&utm_product=project",
        },
        {
            id:9,
            img: michigan_sql,
            title: "Introduction to Structural Query Language (SQL)", 
            link: 'https://coursera.org/share/18a06b0e7cc6053bbe82299e670aa52a',
        },
        {
            id:10,
            img: react_basic,
            title: "React Basics",
            link: 'https://coursera.org/share/4292a69ffca4738dfebf707a3e76d14b',
        },
        {
            id:11,
            img: advanced_react,
            title: "Advanced React",
            link: 'https://coursera.org/share/d7b1009ecdb3db7421f52ad7b197af74',
        },
        {
            id:12,
            img: javascript_img,
            title: "Programming with JavaScript",
            link: 'https://coursera.org/share/1d40793c132a595c80b3aea2ee6cc40d',
        },
        {
            id:13,
            img: v_control,
            title: "Version Control",
            link: 'https://coursera.org/share/0c297d3782b798bfb123d9e8e6eeb3f7',
        },
        {
            id:14,
            img: ux_ui,
            title: "Principles of Ux/UI",
            link: 'https://coursera.org/share/6e8d12d540903d196c26edb4a6813c00',
        },
        {
            id:15,
            img: version_control,
            title: "AWS: Code, Build and Deploy",
            link: 'https://coursera.org/share/0c297d3782b798bfb123d9e8e6eeb3f7',
        },
        {
            id:16,
            img: interview_preparation,
            title: "Interview Preparation",
            link: 'https://coursera.org/share/ebbbe7b9fafdf2b0028f2aab47ef3dd4',
        },
        {
            id:17,
            img: developer_capstone,
            title: "Front-End Developer Capstone",
            link: 'https://coursera.org/share/a7860818d487595aa892241102f7c23e',
        },
        {
            id:18,
            img: trello,
            title: "Trello Project Management",
            link: 'https://www.coursera.org/account/accomplishments/verify/3X2CUQFYQ5UZ?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=sharing_cta&utm_product=project',
        },
        {
            id:19,
            img: michigan,
            title: "Introduction to HTML5",
            link: 'https://coursera.org/share/da0eacf52c37759cfc13981a9ee6f4dc',
        },
    ]
}

export default data;